import { RadioGroup } from '@material-ui/core';
import { withStyles, createStyles } from '@material-ui/core/styles';

export default withStyles(theme => createStyles({}))(RadioGroup);
